// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"LZ-z","subtitle":"MZ-z","wrapper":"NZ-z","leftArrow":"OZ-z","rightArrow":"PZ-z"};